import { BLOCK_TYPES as e } from "./constants.js";
//#region src/blocks-document.ts
var t = class t {
	blocks;
	stepsSinceLastChange;
	constructor(e = [], t = []) {
		this.blocks = e, this.stepsSinceLastChange = t;
	}
	get onlyAttachmentListBlock() {
		return this.blocks.find((t) => t.type === e.ATTACHMENT_LIST);
	}
	get excludingAttachmentListBlock() {
		return new t(this.blocks.filter((t) => t.type !== e.ATTACHMENT_LIST), this.stepsSinceLastChange);
	}
	equals(e) {
		return e === this || JSON.stringify(e.blocks) === JSON.stringify(this.blocks);
	}
	append(e) {
		return e ? new t(this.blocks.slice(0).concat(e), this.stepsSinceLastChange) : new t(this.blocks.slice(0), this.stepsSinceLastChange);
	}
	appendMultiple(e) {
		let n = e.filter((e) => e != null);
		return n.length > 0 ? new t(this.blocks.slice(0).concat(n), this.stepsSinceLastChange) : new t(this.blocks.slice(0), this.stepsSinceLastChange);
	}
};
//#endregion
export { t as BlocksDocument };
